/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {parseExtendedAttributes} from '@ion/core/src/services/ConnectUtils';
import {Account, Asset, GenericObject} from '@ion/core/src/types/entities';
import {isObjectEmpty} from '@ion/core/src/utils/ObjectUtil';
import {FormState} from '../hooks/useFormState';
import {GroupFormFields} from './GroupEditorUtils';

// field names for common validation and prefill the values.
enum CommonValidationFields {
  OverrideOdometer = 'overrideOdometer',
  OverrideEngineRunTime = 'overrideEngineRunTime',
  OverrideSpeed = 'overrideSpeed',
}

/**
 * @verifyCommonAttributes
 *
 * This function takes all selected assets and prefill the valus in Edit form if valudates are identical.
 *
 * @param {Asset[]} assets: selected Assets
 */
export const verifyCommonAttributes = (assets: Asset[]) => {
  const reference = assets[0];
  const getInitialState = (name: string) => {
    const val = reference[name]?.value;
    return {
      value : assets.every((asset) => asset[name].value === val) ? val : null,
      name
    };
  };
  const state = {};
  Object.entries(CommonValidationFields).forEach(([field, prop]) => {
    state[CommonValidationFields[field]] = getInitialState(prop);
  });
  return state;
};
